import { FieldValues, Path, UseFormRegister } from "react-hook-form";
import { lang } from "../../assets/languages/en.language";
import { formConfig } from "../../configs/form.config";
import { FormLabel, StyledInput, StyledInputWrapper } from "../../styles/Form";
import { Gap } from "../../styles/Utils";

interface EmailInputProps<T extends FieldValues> {
  register: UseFormRegister<T>; // Register function from RHF
  name: Path<T>; // The field name should be a key from the form data type
  disabled?: boolean;
}

export default function EamilInput<T extends FieldValues>({ register, name, disabled }: EmailInputProps<T>) {
  return (
    <StyledInputWrapper>
      <FormLabel>{lang?.landingPage.form.email.label}</FormLabel>
      <Gap $height={0.5} />
      <StyledInput
        {...register(name, {
          required: true,
          pattern: {
            value: formConfig.email.regex,
            message: lang.inputs.emailPattern,
          },
          maxLength: {
            value: formConfig.email.maxLength,
            message: lang.inputs.emailLenght,
          },
        })}
        placeholder={lang.landingPage.form.email.placeholder}
        type="email"
        disabled={disabled}
      />
    </StyledInputWrapper>
  );
}
